import React, {useEffect, useState} from 'react';
import {Security} from "../../../models/security";
import SecurityService from "../../../services/security-service";
import pdfIcon from "../../../assets/pdf.svg";
import {Card, Col, Row, Table} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import styles from './security-list.module.scss'
import {toCurrency} from "../../../helpr/helper";
import Loading from "../../../components/loading/loading";
import acceptIcon from "../../../assets/orders-table-accept.svg";
import pendingIcon from "../../../assets/orders-table-pending.svg";
import {SECURITY_AUTHORIZED, SECURITY_SUBMITTED, SECURITY_ADCU_REJECTED} from "../../../helpr/constants";

const SecurityList = () => {
  console.log('SecurityList: rendering');
  //Set spinner state
  const [loading, setLoading] = useState(true);
  //Use history for security detail redirect
  const navigate = useNavigate();
  //Get username and security state dispatcher
  const [securityList, setSecurityList] = useState([]);
  //Initialize Service
  const securityService = new SecurityService();
  //Table Headers
  const headers = [
    "Name",
    "Offer Size",
    "Allocation",
    "Amount Reserved",
    "Offer Period",
    "Status",
    "Download"
  ]

  // Unmount component
  useEffect(()=>{
    return () => {
      console.log('unmounting');
    }
  },[])

  useEffect(()=> {
    const initializeSecurityList = async () => {
      console.log('SecurityList: initializeSecurityList running');
      try {
        const result = await securityService.getListOfSecuritiesOnOffer();
        console.log({result});
        const securityList = result.map(s => new Security(s));
        setSecurityList(securityList);
      } catch(error){
        console.error('SecurityList error:', error);
        navigate(`/internal-server-error`);
      } finally {
        setLoading(false);
      }
    }
    initializeSecurityList();
    // eslint-disable-next-line
  }, []);

  const seeSecurityDetails = (securityId) => {
    navigate(`/securities/${securityId}`);
  }

  const downloadTermSheetAndProspectus = async (securityId) => {
    const result = await securityService.getSecurityDocument(securityId);
    let newWindow = window.open(result['termsheetUrl'], '_blank', 'noopener,noreferrer');
    newWindow = window.open(result['prospectusUrl'], '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  }

  return loading ? <Loading fullscreen={true}/> : (
    <div className={styles['security-list-table']}>
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <h1>Securities On Offer</h1>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead data-testid="security-headers">
                <tr>
                  {headers.map(
                    (header, index) => {
                      return <th key={index}>{header}</th>
                    }
                  )}
                </tr>
                </thead>
                <tbody>
                {
                  securityList.map((data, index) => {
                    return (
                      <tr key={index}>
                        <td className={styles['security-name']} onClick={()=>seeSecurityDetails(data.securityId)}>
                          <img className={styles['title-icon']} src={`${process.env.REACT_APP_ASSETS_URL}${data.iconUrlSrc}`}/>
                          <span className={styles['security-name-span']}>{data.securityName}<br />
                            <span className={styles['issuer-span']}>{data.issuer}</span>
                          </span>
                        </td>
                        <td onClick={()=>seeSecurityDetails(data.securityId)}>
                          {data.currency}{' '}{toCurrency(data.offerSize)}
                        </td>
                        <td onClick={()=>seeSecurityDetails(data.securityId)}>
                          {data.currency}{' '}{toCurrency(data.allocation)}
                        </td>
                        <td>
                          {data.currency}{' '}{toCurrency(data.amountOrdered)}
                        </td>
                        <td className={styles['offer-date']} onClick={()=>seeSecurityDetails(data.securityId)}>{`${data.offerDate} - ${data.offerCloseDate}`}</td>
                        <td>
                          {renderStatus(data.securityStatus)}
                        </td>
                        <td >
                          <img onClick={()=>downloadTermSheetAndProspectus(data.securityId)}className={styles['download-icon']} src={pdfIcon}/>
                        </td>
                      </tr>
                    )
                  })
                }
                </tbody>
              </Table>
              {securityList.length === 0 ? <div className={styles['no-data']}>No securities on offer.</div> : ''}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

const renderStatus = (status) => {
  switch(status){
    case SECURITY_SUBMITTED:
      return <span><img alt="Submitted" src={acceptIcon}/>  Submitted</span>
    case SECURITY_AUTHORIZED:
      return <span><img alt="Approved" src={acceptIcon}/>  Authorized</span>
    case SECURITY_ADCU_REJECTED:
      return <span><img alt="Pending" src={pendingIcon}/>  Ongoing</span>
    default:
      return <span><img alt="Pending" src={pendingIcon}/>  Ongoing</span>
  }
}

export default SecurityList;
